import { User, Project, Resource, Connection } from '../types';

export const mockUsers: User[] = [
  {
    id: 'user_emprendedor_1',
    name: 'María González',
    email: 'maria.gonzalez@example.com',
    role: 'Emprendedor',
    avatar: 'MG',
    createdAt: '2024-01-15T10:00:00Z',
    status: 'active',
    projectIds: ['p1']
  },
  {
    id: 'user_emprendedor_2',
    name: 'Carlos Ramírez',
    email: 'carlos.ramirez@example.com',
    role: 'Emprendedor',
    avatar: 'CR',
    createdAt: '2024-02-01T10:00:00Z',
    status: 'active',
    projectIds: ['p2']
  },
  {
    id: 'user_emprendedor_3',
    name: 'Ana Martínez',
    email: 'ana.martinez@example.com',
    role: 'Emprendedor',
    avatar: 'AM',
    createdAt: '2024-03-10T10:00:00Z',
    status: 'active',
    projectIds: ['p3']
  },
  {
    id: 'user_emprendedor_4',
    name: 'Luis Fernández',
    email: 'luis.fernandez@example.com',
    role: 'Emprendedor',
    avatar: 'LF',
    createdAt: '2024-01-20T10:00:00Z',
    status: 'active',
    projectIds: ['p4']
  },
  {
    id: 'user_mentor_1',
    name: 'Dr. Roberto Silva',
    email: 'roberto.silva@example.com',
    role: 'Mentor',
    expertise: 'Finanzas',
    avatar: 'RS',
    createdAt: '2023-11-01T10:00:00Z',
    status: 'active'
  },
  {
    id: 'user_mentor_2',
    name: 'Dra. Patricia López',
    email: 'patricia.lopez@example.com',
    role: 'Mentor',
    expertise: 'Marketing Digital',
    avatar: 'PL',
    createdAt: '2023-12-01T10:00:00Z',
    status: 'active'
  },
  {
    id: 'user_mentor_3',
    name: 'Ing. Jorge Herrera',
    email: 'jorge.herrera@example.com',
    role: 'Mentor',
    expertise: 'Tecnología',
    avatar: 'JH',
    createdAt: '2023-10-15T10:00:00Z',
    status: 'active'
  },
  {
    id: 'user_mentor_4',
    name: 'Lic. Sandra Torres',
    email: 'sandra.torres@example.com',
    role: 'Mentor',
    expertise: 'Recursos Humanos',
    avatar: 'ST',
    createdAt: '2024-01-05T10:00:00Z',
    status: 'active'
  },
  {
    id: 'user_admin_1',
    name: 'Admin Principal',
    email: 'admin@ingenioe2hub.com',
    role: 'Admin',
    avatar: 'AP',
    createdAt: '2023-01-01T10:00:00Z',
    status: 'active'
  },
  {
    id: 'user_admin_2',
    name: 'Coordinador General',
    email: 'coordinador@ingenioe2hub.com',
    role: 'Admin',
    avatar: 'CG',
    createdAt: '2023-01-01T10:00:00Z',
    status: 'active'
  }
];

export const mockProjects: Project[] = [
  {
    id: 'p1',
    name: 'EcoTech Solutions',
    description: 'Plataforma de gestión de residuos inteligente usando IoT',
    stage: 'Validación',
    industry: 'Tecnología Ambiental',
    ownerId: 'user_emprendedor_1',
    documents: [],
    milestones: [],
    createdAt: '2024-01-15T10:00:00Z',
    updatedAt: '2024-04-01T10:00:00Z'
  },
  {
    id: 'p2',
    name: 'HealthConnect',
    description: 'App de telemedicina para zonas rurales',
    stage: 'Crecimiento Temprano',
    industry: 'Salud Digital',
    ownerId: 'user_emprendedor_2',
    documents: [],
    milestones: [],
    createdAt: '2024-02-01T10:00:00Z',
    updatedAt: '2024-04-15T10:00:00Z'
  },
  {
    id: 'p3',
    name: 'EduPlay',
    description: 'Plataforma educativa gamificada para niños',
    stage: 'Idea',
    industry: 'EdTech',
    ownerId: 'user_emprendedor_3',
    documents: [],
    milestones: [],
    createdAt: '2024-03-10T10:00:00Z',
    updatedAt: '2024-03-25T10:00:00Z'
  },
  {
    id: 'p4',
    name: 'AgriSmart',
    description: 'Sistema de agricultura de precisión con IA',
    stage: 'Validación',
    industry: 'AgTech',
    ownerId: 'user_emprendedor_4',
    documents: [],
    milestones: [],
    createdAt: '2024-01-20T10:00:00Z',
    updatedAt: '2024-04-10T10:00:00Z'
  }
];

export const mockResources: Resource[] = [
  {
    id: 'resource_curso_1',
    name: 'Curso de Lean Startup',
    type: 'Curso',
    description: 'Metodología para validación de modelos de negocio'
  },
  {
    id: 'resource_curso_2',
    name: 'Marketing Digital Avanzado',
    type: 'Curso',
    description: 'Estrategias de marketing para startups'
  },
  {
    id: 'resource_curso_3',
    name: 'Finanzas para Emprendedores',
    type: 'Curso',
    description: 'Gestión financiera y búsqueda de inversión'
  },
  {
    id: 'resource_fondo_1',
    name: 'Fondo Semilla Innovación',
    type: 'Fondo de Inversión',
    description: 'Capital semilla hasta $50,000 USD'
  },
  {
    id: 'resource_fondo_2',
    name: 'Aceleradora TechGrowth',
    type: 'Fondo de Inversión',
    description: 'Programa de aceleración con inversión'
  },
  {
    id: 'resource_herramienta_1',
    name: 'Canvas de Modelo de Negocio',
    type: 'Herramienta',
    description: 'Plantilla interactiva para diseñar modelos de negocio'
  }
];

export const mockConnections: Connection[] = [
  // Mentorías
  {
    id: 'conn_1',
    source: 'user_mentor_1',
    target: 'user_emprendedor_1',
    label: 'Mentoría Finanzas'
  },
  {
    id: 'conn_2',
    source: 'user_mentor_2',
    target: 'user_emprendedor_2',
    label: 'Mentoría Marketing'
  },
  {
    id: 'conn_3',
    source: 'user_mentor_3',
    target: 'user_emprendedor_3',
    label: 'Mentoría Tecnología'
  },
  {
    id: 'conn_4',
    source: 'user_mentor_1',
    target: 'user_emprendedor_4',
    label: 'Mentoría Finanzas'
  },
  {
    id: 'conn_5',
    source: 'user_mentor_4',
    target: 'user_emprendedor_1',
    label: 'Mentoría RRHH'
  },
  // Emprendedores inscritos en cursos
  {
    id: 'conn_6',
    source: 'user_emprendedor_1',
    target: 'resource_curso_1',
    label: 'Inscrito'
  },
  {
    id: 'conn_7',
    source: 'user_emprendedor_2',
    target: 'resource_curso_2',
    label: 'Inscrito'
  },
  {
    id: 'conn_8',
    source: 'user_emprendedor_3',
    target: 'resource_curso_1',
    label: 'Inscrito'
  },
  {
    id: 'conn_9',
    source: 'user_emprendedor_4',
    target: 'resource_curso_3',
    label: 'Inscrito'
  },
  // Emprendedores aplicando a fondos
  {
    id: 'conn_10',
    source: 'user_emprendedor_1',
    target: 'resource_fondo_1',
    label: 'Aplicando'
  },
  {
    id: 'conn_11',
    source: 'user_emprendedor_2',
    target: 'resource_fondo_2',
    label: 'Aceptado'
  },
  {
    id: 'conn_12',
    source: 'user_emprendedor_4',
    target: 'resource_fondo_1',
    label: 'Aplicando'
  },
  // Uso de herramientas
  {
    id: 'conn_13',
    source: 'user_emprendedor_1',
    target: 'resource_herramienta_1',
    label: 'Usando'
  },
  {
    id: 'conn_14',
    source: 'user_emprendedor_3',
    target: 'resource_herramienta_1',
    label: 'Usando'
  }
];
